import React from 'react';
import { Folder } from 'lucide-react';

const getDateValue = (value) => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value.toDate === 'function') return value.toDate();

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatChatDate = (chat = {}) => {
  const date =
    getDateValue(chat.lastMessageSent) ||
    getDateValue(chat.updatedAt) ||
    getDateValue(chat.createdAt);

  if (date) {
    return new Intl.DateTimeFormat(undefined, {
      month: 'short',
      day: 'numeric',
    }).format(date);
  }

  return chat.lastMessageTimeAgo || '';
};

const getChatSubtitle = (chat = {}) =>
  chat.lastMessagePreview ||
  chat.preview ||
  chat.summary ||
  chat.model ||
  '';

const WorkspaceHome = ({
  project,
  chats = [],
  onChatSelect,
  renderComposer,
}) => {
  const workspaceName = project?.name || 'Workspace';

  return (
    <div className="mx-auto flex min-h-full w-full max-w-4xl flex-col pt-[15vh]">
      <div className="mb-7 flex items-center gap-3">
        <Folder size={34} strokeWidth={1.8} className="flex-shrink-0 text-gray-950 dark:text-white" />
        <h1 className="min-w-0 truncate text-3xl font-semibold text-gray-950 dark:text-white">
          {workspaceName}
        </h1>
      </div>

      <div className="mb-8 w-full">
        {renderComposer?.()}
      </div>

      <div className="w-full">
        {chats.length > 0 ? (
          chats.map((chat) => {
            const subtitle = getChatSubtitle(chat);
            const chatDate = formatChatDate(chat);

            return (
              <button
                key={chat.id}
                type="button"
                onClick={() => onChatSelect?.(chat.id)}
                className="group grid w-full grid-cols-[minmax(0,1fr)_auto] items-center gap-4 rounded-lg border-b border-black/5 px-4 py-4 text-left transition-colors hover:bg-black/[0.035] dark:border-white/10 dark:hover:bg-white/[0.06]"
              >
                <div className="min-w-0">
                  <div className="truncate text-base font-semibold text-gray-950 dark:text-white">
                    {chat.topic || 'Untitled Chat'}
                  </div>
                  {subtitle && (
                    <div className="mt-1 truncate text-sm text-gray-500 dark:text-gray-400">
                      {subtitle}
                    </div>
                  )}
                </div>
                {chatDate && (
                  <span className="text-sm text-gray-500 dark:text-gray-400">
                    {chatDate}
                  </span>
                )}
              </button>
            );
          })
        ) : (
          <div className="rounded-lg border border-dashed border-black/10 py-10 text-center text-sm text-gray-500 dark:border-white/15 dark:text-gray-400">
            No chats in this workspace yet.
          </div>
        )}
      </div>
    </div>
  );
};

export default WorkspaceHome;
